import { loadDismissScrollMore, setDismissScrollMore } from "@/common/utils/storage";
import { CurrentUserObject } from "@/common/hooks/useVisitorInfo";
import { useUserSettingsHandlers } from "@/common/hooks/useUserSettingsHandlers";

export const useDismissScrollMore = (user: CurrentUserObject | null) => {
  const { updateUserSettings } = useUserSettingsHandlers();

  return {
    isDismissScrollMore: () => {
      let value = loadDismissScrollMore();

      if (user && user?.settings?.dismiss_scroll_more) {
        value = true;
      }

      return value;
    },
    dismissScrollMore: () => {
      setDismissScrollMore(true);

      if (user && Object.entries(user).length > 0) {
        updateUserSettings({
          dismiss_scroll_more: true,
        });
      }
    }
  };
};
